import { addSwatchLabels } from "../utilities/addSwatchLabels";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { swatchUrlChanger } from "../utilities/Helpers/UI/SwatchUrlChanger";

document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll('[data-section-type="related-articles"]');
    sections.forEach((section) => {
        LUC.jsFeaturedCollection.init(section);
    });
});

LUC.jsFeaturedCollection = {
    init: function ($section) {
        const productBlocks = $section.querySelectorAll(".c-grid__meta");
        if (productBlocks.length > 0) {
            addSwatchLabels(productBlocks);
            swatchUrlChanger(productBlocks);
        }

        const sliderEl = $section.querySelector("[data-hp-slider]");
        if (sliderEl) {
            const typeOfSlider = sliderEl.dataset.hpSlider;
            let config = {
                modules: [Navigation],
                slidesPerView: 1.1,
                spaceBetween: 0,
                centeredSlides: false,
                loop: true,
                autoplay: false,
                allowTouchMove: true,
                keyboard: true,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                    },
                    2048: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                    },
                },
                a11y: {
                    containerMessage: "Slider",
                    containerRoleDescriptionMessage: "Slider Container",
                    nextSlideMessage: "Next slide",
                    prevSlideMessage: "Previous slide",
                    paginationBulletMessage: "Jump to slide {{index}}",
                    slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                    slideRole: "group",
                    itemRoleDescriptionMessage: "Slide group",
                },
            };
            if (typeOfSlider != "bestsellers") {
                config = {
                    modules: [Navigation],
                    slidesPerView: 1.1,
                    spaceBetween: 0,
                    centeredSlides: false,
                    loop: true,
                    autoplay: false,
                    allowTouchMove: true,
                    keyboard: true,
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 0,
                        },
                    },
                    a11y: {
                        containerMessage: "Bestsellers slider",
                        containerRoleDescriptionMessage: "Bestsellers Slider Container",
                        nextSlideMessage: "Next slide",
                        prevSlideMessage: "Previous slide",
                        paginationBulletMessage: "Jump to slide {{index}}",
                        slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                        slideRole: "group",
                        itemRoleDescriptionMessage: "Slide group",
                    },
                };
            }
            LUC.jsFeaturedCollection.createSlider(sliderEl, config);
        }
    },

    createSlider(sliderEl, config) {
        const prevArrow = sliderEl.querySelector("[data-f-collection-btn-prev]");
        const nextArrow = sliderEl.querySelector("[data-f-collection-btn-next]");

        config.navigation = {
            nextEl: nextArrow,
            prevEl: prevArrow,
        };
        new Swiper(sliderEl, config);
    },

    unload: function ($section) {},
};
